import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

// MSAL popup auth (loginPopup / acquireTokenPopup) opens a browser popup that
// redirects back to this origin after Azure AD authentication. Without this
// guard the full SPA renders in the popup, flashing the app UI before MSAL in
// the parent window can read the auth response and close the popup. Detect the
// popup context and skip rendering so MSAL can handle it cleanly.
//
// IMPORTANT: only skip rendering when an actual MSAL auth response is present
// in the URL. Safari sets window.opener for many external-link navigations
// (e.g. links from email or Microsoft portals), so checking window.opener
// alone would prevent the app from mounting in regular Safari tabs.
const hasMsalResponse =
  window.location.hash.includes('code=') ||
  window.location.hash.includes('error=') ||
  window.location.search.includes('code=') ||
  window.location.search.includes('error=');
const isInPopup =
  window.opener != null && window.opener !== window && hasMsalResponse;

if (!isInPopup) {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
